<template>
  <Card
    :class="$style.container"
    noBorder
  >
    <div
      ref="listOfNonDefaultFeatures"
      :class="$style.cart"
    >
      <transition-group
        :enterActiveClass="$style.fadeEnterActive"
        :enterClass="$style.fadeEnter"
        :leaveActiveClass="$style.fadeLeaveActive"
        :leaveToClass="$style.fadeLeaveTo"
        name="fade"
      >
        <div
          v-for="addOn in selectedAddOns"
          :key="addOn.productCode"
          :class="[$style.addOn, $style.selectedAddOn]"
          :data-test-id="`ListOfFeaturesCart_selectedAddOn_${addOn.productCode}`"
        >
          <span>
            <Icon
              :icon="addOn.icon"
              inline
            />
            <span>{{ addOn.displayName }}</span>
          </span>
          <Pill
            v-if="specialAddOnsProductCodes.includes(addOn.productCode)"
            :class="$style.addOnBadge"
            data-test-id="ListOfFeaturesCard__specialAddOnPill"
            text="add-on"
          />
          <span>
            ${{ getAddOnPrice(addOn) }}
          </span>
        </div>
      </transition-group>
    </div>
  </Card>
</template>

<script>
import {
  Card,
  Icon,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import Pill from 'client/components/Buttons/Pill.vue';

const pricingModule = 'PricingModule';
const checkoutModel = 'CheckoutModel';
const addOnCollection = 'AddOnCollection';

export default {
  name: 'ListOfFeaturesCard',

  components: {
    Card,
    Icon,
    Pill,
  },

  computed: {
    ...mapGetters(addOnCollection, {
      specialAddOns: 'getCollection',
    }),

    ...mapGetters(pricingModule, {
      subscriptionIsAnnual: 'getIsAnnual',
    }),

    ...mapGetters(checkoutModel, {
      selectedAddOns: 'getSelectedAddOns',
    }),

    specialAddOnsProductCodes() {
      return this.specialAddOns?.map((addOn) => addOn.productCode);
    },
  },

  watch: {
    selectedAddOns() {
      setTimeout(() => {
        const { listOfNonDefaultFeatures } = this.$refs;
        listOfNonDefaultFeatures.scrollTop = listOfNonDefaultFeatures.scrollHeight;
      }, 100);
    },
  },

  created() {
    this.fetchAddOns();
  },

  methods: {
    ...mapActions(addOnCollection, {
      fetchAddOns: 'fetchCollection',
    }),

    getAddOnPrice(addOn) {
      return this.subscriptionIsAnnual ? addOn.annualPrice : addOn.listPrice;
    },
  },
};
</script>

<style module scoped>
/* Transition classes defined here */
@import '../../components/FormValidation/css/formFields.css';

@value (jcGrey900, jcWarning100) from '~css/brand-colors.css';

.addOn {
  display: flex;
  gap: var(--jc-spacer);
  justify-content: space-between;
}

.addOnBadge {
  background: jcWarning100;
  border-radius: 4px;
  color: jcGrey900;
  font-size: 10px;
  font-weight: 700;
  position: relative;
  text-transform: uppercase;
}

.cart {
  border: var(--jc-border);
  border-radius: var(--jc-border-radius);
  margin: var(--jc-spacer) 0;
  overflow-y: auto;
}

.container {
  display: grid;
  grid-template-rows: auto 1fr;
  text-align: left;
}

.defaultAddOn {
  color: var(--jc-color-disabled-text);
  margin: 0 var(--jc-spacer);
}

.selectedAddOn {
  margin: var(--jc-spacer);
}
</style>
